/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/how-to/querying-data/use-static-query/
 */

import * as React from "react"
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import Stack from 'react-bootstrap/Stack';
import { Typography } from "@mui/material";

function ExpandableTable(props) {
  const [open, setOpen] = React.useState(null);

  const rows=props.rows;

  const tableRows=rows.map((row)=><tr>
  <td><Stack gap={1}>
  <Stack direction="horizontal" gap={0}>    
  <Button variant="light" style={{width:"96%", textAlign: "left"}} onClick={()=>{
    if (open!=null && open==row.index) {setOpen(null);}
    else {setOpen(row.index);}
  }}>
        <Typography variant="body1"><b>{row.title}</b></Typography>
        
      </Button><div>{open==row.index?<RemoveIcon />:<AddIcon />}</div>
      </Stack> 
      <div>{open==row.index? row.content:<></>}   </div>      
</Stack>  
      </td>
</tr>);

  return (
    <>
      <Table bordered>
      <tbody>
        {tableRows}
      </tbody>
    </Table>
    </>
  )
}

export default ExpandableTable;
